import { render, staticRenderFns } from "./RiskConferenceWarningUpdate.vue?vue&type=template&id=8379ff06&scoped=true&"
import script from "./RiskConferenceWarningUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceWarningUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RiskConferenceWarningUpdate.vue?vue&type=style&index=0&id=8379ff06&scoped=true&lang=css&"
import style1 from "./RiskConferenceWarningUpdate.vue?vue&type=style&index=1&id=8379ff06&lang=scss&scoped=true&"
import style2 from "./RiskConferenceWarningUpdate.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8379ff06",
  null
  
)

export default component.exports